import { EmptyState } from '@personachat/ui';
import { Compass } from 'lucide-react';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <EmptyState
      icon={<Compass size={28} />}
      title="Page introuvable"
      text="Ce lien ne correspond à aucun écran du back-office."
      action={
        <Link className="ui-btn ui-btn--secondary" to="/">
          Revenir au tableau de bord
        </Link>
      }
    />
  );
}
